import AuthActionPage from "./AuthActionPage";

export default AuthActionPage;
